module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-wedding-bed466b1be672da4fa675ea54bc92654.svg";